var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFileUpload = function SvgFileUpload(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.156,
    y: 13.178,
    width: 51.82,
    height: 69.093,
    rx: 6,
    transform: "rotate(-14.732 .156 13.178)",
    fill: "#E3D2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#file-upload_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.637 5.453v17.274H59.91L42.637 5.453ZM44.16 33.63 26.888 40a2.154 2.154 0 0 0-1.525 2.065v15.492a8.942 8.942 0 0 0-2.159-.284c-3.576 0-6.477 1.943-6.477 4.319 0 2.375 2.9 4.318 6.477 4.318 3.576 0 6.478-1.943 6.478-4.318V47.975l12.955-5.06v10.307a9.812 9.812 0 0 0-2.16-.267c-3.576 0-6.477 1.94-6.477 4.318 0 2.378 2.901 4.319 6.477 4.319 3.577 0 6.478-1.941 6.478-4.319V35.681c0-.691-.32-1.332-.877-1.738a2.166 2.166 0 0 0-1.917-.313Z",
    fill: "#751CBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.636 22.727V5.453H14.567a6.477 6.477 0 0 0-6.477 6.478v56.138c0 3.576 2.9 6.477 6.477 6.477h38.865c3.578 0 6.478-2.9 6.478-6.477V22.726H42.637Zm4.319 34.546c0 2.378-2.901 4.319-6.478 4.319-3.576 0-6.477-1.944-6.477-4.319s2.901-4.318 6.477-4.318c.726 0 1.451.101 2.16.27v-10.31l-12.956 5.06v13.617c0 2.377-2.9 4.318-6.477 4.318-3.576 0-6.477-1.943-6.477-4.318 0-2.376 2.9-4.319 6.477-4.319.725 0 1.45.101 2.16.27V42.065c0-.945.607-1.782 1.524-2.065l17.273-6.377a2.19 2.19 0 0 1 1.917.318c.553.404.877 1.052.877 1.74v21.592Z",
    fill: "#C8A4E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "file-upload_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(8.09 5.453)",
    d: "M0 0h51.82v69.093H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFileUpload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "52c85b7b9465751f15d947222fb15ccb.svg";